import { render, staticRenderFns } from "./PersonalesPrecalificacion.vue?vue&type=template&id=65066f9a&lang=html&"
import script from "./PersonalesPrecalificacion.vue?vue&type=script&lang=js&"
export * from "./PersonalesPrecalificacion.vue?vue&type=script&lang=js&"
import style0 from "./PersonalesPrecalificacion.vue?vue&type=style&index=0&id=65066f9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports